import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=0061557e&scoped=true&"
import script from "./LinkItem.vue?vue&type=script&lang=js&"
export * from "./LinkItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkItem.vue?vue&type=style&index=0&id=0061557e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061557e",
  null
  
)

export default component.exports